import { get, post, patch } from "../web.request";


export const changePassword = async (data, id) => {
    return await post(`users/changepassword/${id}`, data);
}
